import React, { useEffect, useState } from 'react';
import { BannerWrapper, Wrapper } from './styled';
import Layout from '../../components/Layout';
import { useLocation } from 'react-router-dom';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Pagination from '../../components/Pagination';
import { useRecoilState, useRecoilValue } from 'recoil';
import { seriresAtom, seriresNumAtom, shuffleAtom } from '../../atom/taxonomy';
import { GetPosts, GetSeriesNum, GetTags } from '../../service/blog';
import {
	SkeletonBanner,
	SkeletonList,
	SkeletonListRight,
	SkeletonMoBanner,
	SkeletonMoRight,
	SkeletonRightTag,
} from '../../components/Skeleton';

const List = () => {
	const series_ = [
		{
			seriesimg: '/images/series01.png',
			title: '공헌자들',
			total: '게시글 17개',
		},
		{
			seriesimg: '/images/series02.png',
			title: '리드앤라이트',
			total: '게시글 17개',
		},
		{
			seriesimg: '/images/series03.png',
			title: '일잘러들',
			total: '게시글 17개',
		},
	];

	const params = useParams();
	const series = useRecoilValue(seriresAtom);
	const [shuffle, setShuffle] = useRecoilState(shuffleAtom);
	const nav = useNavigate();
	const query = new URLSearchParams(useLocation().search);
	const searchPaged = query.get('paged');

	console.log(series, 123);

	console.log(params?.ID, 77);

	const [paged, setPaged] = useState(searchPaged || 1);
	const postsPerPage = 8;
	const [items, setItems] = useState([]);
	const [total, setTotal] = useState(0);
	const [maxPaged, setMaxPaged] = useState(1);
	const [pocket, setPocket] = useState('');
	const [desc, setDesc] = useState('');
	const [seriesNum, setSeriesNum] = useRecoilState(seriresNumAtom);

	useEffect(() => {
		if (paged > 1) {
			GetPosts({
				paged,
				postsPerPage,
				series: params?.ID,
			})
				.then((res) => {
					console.log(res);
					if (res.data.code == 200) {
						setItems(res.data.body.items);
						setPocket(res.data.body.pocket);
						setDesc(res.data.body.desc);
						setTotal(res.data.body.total);
						setMaxPaged(res.data.body.maxPaged);
					} else {
						setItems(null);
						setDesc(res.data.body.desc);
					}
				})
				.catch((err) => {
					console.log(err);
				});
		}
	}, [paged]);

	useEffect(() => {
		if (paged == 1) {
			setPaged(1);
			GetPosts({
				paged: 1,
				postsPerPage,
				series: params?.ID,
			})
				.then((res) => {
					console.log(res);
					if (res.data.code == 200) {
						setItems(res.data.body.items);
						setPocket(res.data.body.pocket);
						setDesc(res.data.body.desc);
						setTotal(res.data.body.total);
						setMaxPaged(res.data.body.maxPaged);
					} else {
						setItems(null);
						setDesc(res.data.body.desc);
						setPocket(res.data.body.pocket);
					}
				})
				.catch((err) => {
					console.log(err);
				});
		}
	}, [params?.ID, paged]);

	function shuffleArray(array) {
		const shuffledArray = [...array]; // Create a copy of the original array
		for (let i = shuffledArray.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffledArray[i], shuffledArray[j]] = [
				shuffledArray[j],
				shuffledArray[i],
			];
		}
		return shuffledArray;
	}

	useEffect(() => {
		const shuffledObjects = shuffleArray(shuffle);
		console.log(77, shuffledObjects);
		setShuffle(shuffledObjects);
		GetSeriesNum({})
			.then((res) => {
				console.log(res);

				const sortedObjects = [...res.data.body.array]; // Create a copy of the array
				sortedObjects.sort((a, b) => b.value - a.value); // Sort by 'count' in ascending order

				console.log(123, sortedObjects);
				setSeriesNum(sortedObjects);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	const [tags, setTags] = useState([]);

	useEffect(() => {
		GetTags({
			series: params?.ID,
		})
			.then((res) => {
				if (res.data.code == 200) {
					setTags(res.data.body.result);
				} else {
					setTags(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	useEffect(() => {
		console.log('items', items);
		if (items == null) {
			GetTags({})
				.then((res) => {
					if (res.data.code == 200) {
						setTags(res.data.body.result);
					} else {
						setTags(null);
					}
				})
				.catch((err) => {
					console.log(err);
				});
		}
	}, [items]);

	const onPaging = (page) => {
		console.log(page);
		nav(`${window.location.pathname}?paged=${page}`);
		window.scrollTo(0, 0);
		setItems(null);
		setPaged(page);
	};

	return (
		<Layout>
			<title>{pocket} 시리즈 - KBDS 공식블로그</title>
			<meta
				name="description"
				content={`${pocket} 시리즈 - 시리즈의 연재 게시글`}
			/>
			<Wrapper>
				<div className="flex-wrapper">
					{items?.length ? (
						<>
							<div className="mo-top-box">
								<div
									className="topimg"
									style={{
										backgroundImage: `url(${shuffle[4]?.moThumbnail})`,
									}}
								></div>
								<div className="text-box">
									<h3>{pocket}</h3>
									<p>게시글 {total}개</p>
								</div>
							</div>
							<div className="mo-content">
								<p>{desc}</p>
							</div>
						</>
					) : (
						<SkeletonMoRight />
					)}
					<div className="left">
						<div className="article-wrap">
							{/* <h2 className="title">{series[params?.ID]?.title}</h2> */}
							<h2 className="title">{pocket}</h2>
							<div className="flex-wrap">
								<div className="left-box">
									{items?.length ? (
										items.map((item, key) => (
											<>
												<Link
													to={`/blog/${item?.ID}`}
													className="card-box"
													key={key}
												>
													<div className="article-card">
														<div className="cardimgbox">
															<div
																className="article-img"
																style={{
																	backgroundImage: `url(${
																		item?.thumbnail || '/images/no-image.png'
																	})`,
																}}
															></div>
														</div>
														<div className="text-box">
															<div className="tag-box">
																{item?.tags?.length
																	? item?.tags?.map((i, k) => (
																			<>
																				<p className="cate" key={k}>
																					#{i?.name}
																				</p>
																			</>
																	  ))
																	: null}
															</div>
															<h3>{item?.postTitle}</h3>
															<p className="content">{item?.postContent}</p>
															<div className="flex">
																<div className="user-box">
																	{item.authors ? (
																		<>
																			<div className="people">
																				{item.authors.map((i, k) => (
																					<a
																						className="user"
																						style={{
																							backgroundImage: `url(${i?.postAuthorImg})`,
																						}}
																					></a>
																				))}
																			</div>
																		</>
																	) : (
																		<div
																			className="user"
																			style={{
																				backgroundImage: `url(${item?.postAuthorImg})`,
																			}}
																		></div>
																	)}
																</div>
																{item.authors ? null : (
																	<p>{item.postAuthorName}</p>
																)}
																{item.series ? (
																	<p className="name">
																		<img
																			src="/images/icon-lightning.svg"
																			alt=""
																		/>
																		{item?.series}
																	</p>
																) : null}
																<p className="date">{item?.postDate}</p>
															</div>
														</div>
													</div>
												</Link>
												<div className="line"></div>
											</>
										))
									) : items ? (
										<>
											<SkeletonList />
											<SkeletonList />
											<SkeletonList />
											<SkeletonList />
											<SkeletonList />
											<SkeletonList />
											<SkeletonList />
										</>
									) : (
										<div className="result">
											<div className="result-box">
												<p>
													등록된 게시글이 없어요
													<br /> 게시글을 등록해보세요!
												</p>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
						<Pagination
							total={total}
							postsPerPage={postsPerPage}
							paged={paged}
							maxPaged={maxPaged}
							onPaging={onPaging}
						/>
					</div>
					<div className="mo-banner-wrap">
						{items?.length ? (
							<div
								className="mo-banner"
								style={{ backgroundImage: `url(/images/mo-banner.png)` }}
							>
								<p className="title">
									새로운 금융IT 세상을 만들어갈 인재를 모십니다.
								</p>
								<a href="https://kbds.career.greetinghr.com/" target="_blank">
									<span>
										채용공고 보러가기
										<img src="/images/icon-banner-more.svg" alt="" />
									</span>
								</a>
							</div>
						) : (
							<SkeletonMoBanner />
						)}
						<div className="line"></div>
					</div>
					{seriesNum?.length ? (
						<div className="right">
							<div className="top-wrap">
								<div className="top-box">
									<div
										style={{
											backgroundImage: `url(${shuffle[4]?.moThumbnail})`,
										}}
										className="topimg"
									></div>
									<div className="text-box">
										<h3>{pocket}</h3>
										<p>게시글 {total}개</p>
									</div>
								</div>
								<div className="content">
									<p>{desc}</p>
								</div>
							</div>
							<div className="series">
								<h3>추천 포켓</h3>
								<div className="series-list">
									{seriesNum?.length ? (
										shuffleArray(seriesNum)
											.slice(0, 3)
											.map((item, key) => (
												<div className="list" key={key}>
													<Link to={`/blog/series/${item.key}`}>
														<div
															className="seriesimg"
															style={{
																backgroundImage: `url(${shuffle[key]?.moThumbnail})`,
															}}
														></div>
														<div className="text-box">
															{/* <h4>{series[item?.key]?.title}</h4> */}
															<h4>{item?.title}</h4>
															<p>게시글 {item?.value}개</p>
														</div>
													</Link>
												</div>
											))
									) : (
										<></>
									)}
								</div>
							</div>
							<div className="tag">
								<h3>최근 가장 인기있는 태그</h3>
								{tags?.length ? (
									<ul>
										{tags.map((item, key) => (
											<Link to={`/tag/${item?.value?.name}`}>
												<li key={key}>#{item?.value?.name}</li>
											</Link>
										))}
									</ul>
								) : (
									<SkeletonRightTag />
								)}
							</div>
						</div>
					) : (
						<SkeletonListRight />
					)}
				</div>
				<BannerWrapper>
					{1 ? (
						<div
							className="banner"
							style={{ backgroundImage: `url(/images/banner-img02.png)` }}
						>
							<p className="title">
								새로운 금융IT 세상을 만들어갈 인재를 모십니다.
							</p>
							<a href="https://kbds.career.greetinghr.com/" target="_blank">
								<span>
									채용공고 보러가기
									<img src="/images/icon-banner-more.svg" alt="" />
								</span>
							</a>
						</div>
					) : (
						<SkeletonBanner />
					)}
				</BannerWrapper>
			</Wrapper>
		</Layout>
	);
};

export default List;
